import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getProjectById } from "../api/projectService";
import { Title, Meta, Link as SeoLink } from "react-head";

const ProjectDetails = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const data = await getProjectById(id);
        setProject(data);
      } catch (err) {
        setError("Failed to load project details.");
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [id]);

  // Loading state
  if (loading) {
    return (
      <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
        <div className="spinner-border text-primary" role="status"></div>
        <span className="ms-3 fw-semibold">Loading project details...</span>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="error-container text-center py-5">
        <p className="text-danger fs-6">{error}</p>
        <Link to="/projects" className="btn btn-outline-primary mt-3">
          Back to Projects
        </Link>
      </div>
    );
  }

  // Render project details
    return (
        <>
    <Title>{(project?.title || "Project Details") + " | Softition"}</Title>
    <Meta name="description" content={project.description?project.description:''} />
    <SeoLink rel="canonical" href={project?.seo?.canonical ? window.location.href : window.location.href} />


    <section className="py-5 project-details-modern position-relative">
  {/* Gradient Background Accents */}
  <div className="gradient-bg"></div>

  <div className="container position-relative">
    {/* Back Button */}
    <div className="mb-4">
      <Link
        to="/projects"
        className="btn btn-outline-theme2 rounded-pill px-4 shadow-sm back-btn"
      >
        &larr; Back to Projects
      </Link>
    </div>

    <div className="row g-5 align-items-start">
      {/* Left Column - Project Visual */}
      <div className="col-lg-6">
        <div className="image-card rounded-4 overflow-hidden shadow-lg position-relative">
          <img
            src={require(`../assets/images/project/${project.image}`)}
            alt={project.title}
            className="img-fluid rounded-4 project-image"
          />
          <div className="image-overlay d-flex align-items-center justify-content-center">
            <span className="badge badge-glow text-uppercase fw-bold px-4 py-2">
              {project.status || "Live"}
            </span>
          </div>
        </div>
      </div>

      {/* Right Column - Main Info */}
      <div className="col-lg-6">
        <h1 className="fw-bold display-5 text-gradient mb-3">{project.title}</h1>
        <p className="lead text-light-emphasis mb-4">{project.description}</p>

        {/* CTA */}
        <Link
          to="/contact"
          className="btn btn-glow btn-lg rounded-pill px-5 shadow-lg"
        >
          Start Your Project
        </Link>
      </div>
    </div>

    {/* Details Section */}
    <div className="row mt-5 g-4">
      {/* Key Features */}
      <div className="col-md-6">
        <div className="glass-card p-4 rounded-4 shadow-sm h-100">
          <h4 className="fw-bold text-gradient mb-3">Key Features</h4>
          <ul className="list-unstyled mb-0">
            {(project.features || [ ]).map((feature, idx) => (
              <li key={idx} className="mb-2">
                <i className="bi bi-star-fill text-secondary-color me-2"></i>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Key Highlights */}
      <div className="col-md-6">
        <div className="glass-card p-4 rounded-4 shadow-sm h-100">
          <h4 className="fw-bold text-gradient mb-3">Key Highlights</h4>
          <ul className="list-unstyled mb-0">
            {(project.highlights || [ ]).map((item, idx) => (
              <li key={idx} className="mb-2">
                <i className="bi bi-star-fill text-secondary-color me-2"></i>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>

    {/* Tech Stack */}
    <div className="row mt-4">
      <div className="col-12">
        <div className="glass-card p-4 rounded-4 shadow-sm">
          <h4 className="fw-bold text-gradient mb-3">Tech Stack</h4>
          <div className="d-flex flex-wrap gap-3">
            {(project.technologies || [ ]).map((tech, idx) => (
              <span key={idx} className="badge badge-tech px-3 py-2 shadow-sm">
                {tech}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
        
            
    </>
  );
};

export default ProjectDetails;
